export let StepId = /*#__PURE__*/function (StepId) {
  StepId["memberLogin"] = "member-login";
  StepId["customerDetails"] = "contact-details";
  StepId["additionalDetails"] = "additional-details";
  StepId["deliveryMethod"] = "delivery-method";
  StepId["paymentAndPlaceOrder"] = "payment-and-place-order";
  return StepId;
}({});
//# sourceMappingURL=StepId.js.map